module.exports = __webpack_public_path__ + "img/Star_VeryLow.67033c4c.svg";